import { Theme } from '@mui/material/styles'

const useStyles = {
  errorGridContainer: {
    marginTop: '230px',
    justifyContent: 'center',
    alignContent: 'center',
  },
  errorGridContainerFullPage: {
    height: '100vh',
  },
  imageGrid: {
    justifyContent: 'center',
    alignContent: 'center',
  },
  typographyWrapper: (theme: Theme) => ({
    margin: theme.spacing(2, 0, 1),
    textAlign: 'center',
    justifyContent: 'center',
  }),
  buttonsRow: {
    justifyContent: 'center',
    gap: 7,
  },
}

export default useStyles
